import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function MissionSection() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="mission-section">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-8">
                        Why This Exists.
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            The VA industry has a structural problem. Most services are built around placement volume - find a candidate, collect a fee, move on. The client is left with a person and no system around them. When it fails, and it often does, the client blames VAs. The service blames the client. Nobody fixes the actual problem.
                        </p>
                        <p>
                            White Glove Hiring was built to fix the actual problem. One program that addresses every layer - hiring, onboarding, oversight, documentation, and accountability - as one standard. Not a staffing service. Not a software tool. A partner that stays in the relationship.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
